<cerrix-loader [cerrixTab]="tab"></cerrix-loader>

@if (controlModel) {
    <div class="detail-page-action-bar flex-action-bar">
        <div>
            @if (permissions.CanEdit) {
                <button data-uiid="button-savecontrol" class="btn btn-cerrix" (click)="save()">
                    <i class="fas fa-save"></i>
                    <span class="d-none d-lg-inline">{{ 'detail.saveControl' | t }}</span>
                </button>
            }

            <span class="date-edited">
                {{ 'detail.lastSave' | t: { date: (controlModel.DateModified | dateTimeFormat) } }}
            </span>
        </div>

        @if (controlGuid) {
            <div class="workflow-area">
                @if (permissions.CanOpenDi && requiresMonitoringOnInit) {
                    <button
                        (click)="openSimpleTesting(simpleTestingTypes.DesignImplementation)"
                        class="btn btn-dark"
                        data-uiid="btn-open-design-implementation"
                    >
                        <i class="fas fa-external-link-alt"></i>
                        {{ 'detail.designImplementationTesting' | t }}
                    </button>
                }
                @if (permissions.CanOpenControlExecution && requiresExecutionOnInit) {
                    <button
                        (click)="openControlExecution()"
                        class="btn btn-dark"
                        data-uiid="btn-open-control-execution"
                    >
                        <i class="fas fa-external-link-alt"></i>
                        {{ 'detail.controlExecution' | t }}
                    </button>
                }
                @if (requiresMonitoringOnInit) {
                    @if (permissions.CanOpenSimpleEff) {
                        <button
                            (click)="openSimpleTesting(simpleTestingTypes.Effectiveness)"
                            data-uiid="btn-open-simple-effectiveness"
                            class="btn btn-dark"
                        >
                            <i class="fas fa-external-link-alt"></i>
                            {{ 'detail.effectivenessTesting' | t }}
                        </button>
                    }
                    @if (permissions.CanOpenAdvEff) {
                        <button
                            (click)="openAdvOverview()"
                            data-uiid="btn-open-advanced-effectiveness"
                            class="btn btn-dark"
                        >
                            <i class="fas fa-external-link-alt"></i>
                            {{ 'detail.effectivenessTesting' | t }}
                        </button>
                    }
                }
            </div>
        }
    </div>

    <div
        class="control-screen-system"
        menuSystem
        [cerrixTab]="tab"
        (changeEvent)="handleMenuItemClick($event)"
    >
        <div
            class="control-screens"
            [attr.name]="'detail.menuControl' | t"
            menuicon="fas fa-shield-alt"
            menusystemsubmenu
        >
            <div
                menuItemId="menuDetails"
                [attr.name]="'detail.menuDetails' | t"
                menuicon="fas fa-info-circle"
                menusystemitem
            >
                <control-detail-main
                    [controlModel]="controlModel"
                    [cerrixTab]="tab"
                    [permissions]="permissions"
                    #detailMain
                >
                </control-detail-main>
            </div>

            @if (controlGuid) {
                <div
                    [attr.name]="'detail.menuTestResultOverview' | t"
                    [attr.menuItemId]="'menuTestResultOverview'"
                    menuicon="fas fa-vials"
                    menusystemitem
                >
                    <control-test-result
                        [guid]="controlGuid"
                        [cerrixTab]="tab"
                        [permissions]="permissions"
                        #testResult
                    >
                    </control-test-result>
                </div>

                <div
                    class="control-screens"
                    [attr.menuItemId]="'menuLinks'"
                    [attr.name]="'detail.menuLinks' | t"
                    menuicon="fas fa-link"
                    menusystemsubmenu
                >
                    @if (permissions.CanViewRisks) {
                        <div
                            menuItemId="menuItemRisks"
                            [attr.name]="'detail.menuRisks' | t"
                            menuicon="fas fa-exclamation-triangle"
                            menusystemitem
                        >
                            <control-risks [controlModel]="controlModel" #controlRisks>
                            </control-risks>
                        </div>
                    }
                    @if (permissions.CanViewEvents) {
                        <div
                            menuItemId="menuItemEvents"
                            [attr.name]="'detail.menuEvents' | t"
                            menuicon="fas fa-bolt"
                            menusystemitem
                        >
                            <control-events
                                #controlEvents
                                [controlModel]="controlModel"
                                [disabled]="true"
                            >
                            </control-events>
                        </div>
                    }
                    @if (permissions.CanViewBim || permissions.CanViewMoi) {
                        <div
                            menuItemId="menuItemMoi"
                            [attr.name]="'detail.menuMeasuresOfImprovements' | t"
                            menuicon="fas fa-tasks"
                            menusystemitem
                        >
                            <control-mois
                                [permissions]="permissions"
                                [moiType]="cmMoiType"
                                [parentGuid]="controlGuid"
                                [controlModel]="controlModel"
                                #controlMoisComponent
                            >
                            </control-mois>
                        </div>
                    }
                    @if (permissions.CanViewAssets) {
                        <div
                            [attr.name]="'detail.menuAssets' | t"
                            [attr.menuItemId]="assetsMenuItemId"
                            menuicon="fas fa-server"
                            menusystemitem
                        >
                            <app-linked-assets
                                [linkedAssetIds]="controlModel.LinkedAssetIds"
                                [organizationId]="controlModel.Organization"
                                [disabled]="!permissions.CanLinkAssets"
                                (linkedAssetIdsChange)="linkedAssetIdsChanged($event)"
                                #assetsComponent
                            >
                            </app-linked-assets>
                        </div>
                    }
                    @if (permissions.CanViewDm) {
                        <div
                            menuItemId="menuItemDm"
                            [attr.name]="'detail.menuDataProcessing' | t"
                            menuicon="fas fa-database"
                            menusystemitem
                        >
                            <control-datamanagement
                                #controlDmComponent
                                [controlModel]="controlModel"
                                [disabled]="!permissions.CanLinkDm"
                            ></control-datamanagement>
                        </div>
                    }
                    @if (permissions.CanViewTp) {
                        <div
                            menuItemId="menuItemTp"
                            [attr.name]="'detail.menuThirdParty' | t"
                            menuicon="fas fa-handshake"
                            menusystemitem
                        >
                            <control-thirdparty
                                #controlTpComponent
                                [controlModel]="controlModel"
                                [disabled]="true"
                            >
                            </control-thirdparty>
                        </div>
                    }
                    <div
                        menuItemId="menuItemForms"
                        [attr.name]="'detail.menuForms' | t"
                        menuicon="fas fa-file-alt"
                        menusystemitem
                    >
                        <control-forms
                            #formsComponent
                            [controlModel]="controlModel"
                            [disabled]="!permissions.CanLinkForms"
                        ></control-forms>
                    </div>
                    <div
                        menuItemId="menuItemDocuments"
                        [attr.name]="'detail.menuDocuments' | t"
                        menuicon="far fa-file"
                        menusystemitem
                    >
                        @if (documents) {
                            <document-manager-old
                                [(Documents)]="controlModel.Documents"
                                (DocumentsChange)="checkDocumentsDirty()"
                                [permissions]="permissions.DocumentPermissionModel"
                                [DocumentTypeTargets]="targetModule"
                            >
                            </document-manager-old>
                        } @else {
                            <div class="fancy-loader"></div>
                        }
                    </div>
                    <div
                        [attr.name]="'detail.menuHyperlinks' | t"
                        [attr.menuItemID]="hyperlinksMenuItemId"
                        menuicon="fas fa-external-link-alt"
                        menusystemitem
                    >
                        @if (controlModel.Hyperlinks) {
                            <hyperlink-manager
                                [Hyperlinks]="controlModel.Hyperlinks"
                                (HyperlinksChanged)="checkHyperlinksDirty()"
                                [TargetModule]="targetModule"
                            ></hyperlink-manager>
                        } @else {
                            <div class="fancy-loader"></div>
                        }
                    </div>
                </div>

                <div
                    menuItemId="menuItemHistory"
                    [attr.name]="'detail.menuHistory' | t"
                    menuicon="fas fa-history"
                    menusystemitem
                >
                    <app-history-overview [historyDataService]="_controlDS" [Id]="controlGuid">
                    </app-history-overview>
                </div>

                <div menuItemId="Options" [attr.name]="'detail.menuOptions' | t" menuicon="fas fa-check-double" menusystemitem>
                    <detail-options
                        moduleName="control"
                        [objectName]="controlModel ? controlModel.Name : 'control'"
                        [allowDelete]="permissions.CanDelete"
                        (onDelete)="delete()"
                    >
                    </detail-options>
                </div>
            }
        </div>
    </div>
}
